// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__baselGrotesk_51c9a7', '__baselGrotesk_Fallback_51c9a7'"},"className":"__className_51c9a7","variable":"__variable_51c9a7"};